import { FC } from 'react';

import { Badge, Icon, IconTitleContainer, TitleWrapper } from './Title.styled';

export type IconTitleProps = {
  icon?: string;
  title: string;
  value?: number;
};

export const Title: FC<IconTitleProps> = ({ icon, title, value }) => (
  <IconTitleContainer data-testid="icon-title">
    {icon && <Icon src={icon} alt="icon" />}
    <TitleWrapper>{title}</TitleWrapper>
    {value && <Badge>{value}</Badge>}
  </IconTitleContainer>
);
